export interface StudentPagePosition {
  scope: string;
  page: number;
  pageSize: number;
}

// The caller supplies positive page sizes and a position bounded by its page controls.
export function studentPageWindow(position: StudentPagePosition, scope: string, count: number, pageSize: number) {
  const pages = Math.max(1, Math.ceil(count / pageSize));
  // Resizing retains the old first student's index inside the new visible page.
  const page =
    position.scope === scope
      ? Math.min(Math.floor(((position.page - 1) * position.pageSize) / pageSize) + 1, pages)
      : 1;
  return { page, pages, start: (page - 1) * pageSize, end: page * pageSize };
}
